module.exports = __webpack_public_path__ + "img/tddg-5.9a8f088d.jpg";